var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatUnread = function SvgChatUnread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _title || (_title = /*#__PURE__*/React.createElement("title", null, "chat-unread")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.016V6H6v2.016zm-3.984 6V12H6v2.016zM6 9v2.016h12V9zm14.016-6.984c1.078 0 1.969.891 1.969 1.969v12c0 1.078-.891 2.016-1.969 2.016H6l-3.984 3.984v-18c0-1.078.891-1.969 1.969-1.969z"
  })));
};
export default SvgChatUnread;